import { render, staticRenderFns } from "./old-header.vue?vue&type=template&id=ba9ec168&scoped=true&"
import script from "./old-header.vue?vue&type=script&lang=ts&"
export * from "./old-header.vue?vue&type=script&lang=ts&"
import style0 from "./old-header.vue?vue&type=style&index=0&id=ba9ec168&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba9ec168",
  null
  
)

export default component.exports